import PaymentForm from "components/PaymentForm"
import VueForm from "../vue_form"

export default class extends VueForm(PaymentForm) {
  successCallback(response) {
    Turbo.cache.clear()
    Turbo.visit(response["redirect_to"], { action: "replace" })
  }
}
